import React from 'react'
import Container from '../Wrappers/Container'
import NotificationItem from '../Molecules/Items/NotificationItem'
import NotificationCount from '../../static/images/stories/notification-count.svg'

const NotificationsPanel = () => {
  return (
    <Container className='notifications-panel overflow-auto'>

      <header className='s-main-justify'>
        <h3>Notificaciones</h3>
        <a href='#'>Marcar como leídas</a>
      </header>
      <div className='s-column nowrap s-flex-gap-4px'>
        <NotificationItem unread />
        <NotificationItem type='success' />
        <NotificationItem type='advice' />
      </div>

      {/*  Estado vacío para las notificaciones*/}
      {/* <div className="s-column s-cross-center s-main-center s-center nowrap">
        <img
          className="s-w-128px s-mb-24px"
          src={NotificationCount}
        />
        <h3 className="s-mb-6px">Aún no tienes notificaciones</h3>
        <p className="s-mb-0">Pero te avisaremos cuando tengas alguna</p>
      </div>*/}
    </Container>
  )
}

export default NotificationsPanel
